import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { checkAuthentication, acceptInvite } from "../../services/InviteService";
import "./Invite.css";

const InvitePage = () => {
  const { uniqid, title } = useParams();
  const [message, setMessage] = useState("Hazırlık yapılıyor...");
  const navigate = useNavigate();

  const extractProject = (res) => {
    const p = res?.project || res?.data?.project || {};
    const id = p?.id || res?.projectId || res?.id || 0;
    const name = p?.name || res?.title || title || "Proje";
    const uniq = p?.uniq || res?.projectUniq || res?.uniq || "";
    return { uniq, id, name };
  };

  const goToProject = (proj) => {
    const safeName = encodeURIComponent(proj.name);
    navigate(`/bugs/${proj.uniq || proj.id}/0/${safeName}`);
  };

  const handleJoinProject = useCallback(async () => {
    const result = await acceptInvite(uniqid);
    const proj = extractProject(result);
    setMessage("Projeye başarıyla katıldınız, yönlendiriliyor...");
    setTimeout(() => goToProject(proj), 1500);
  }, [uniqid, navigate]);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        setMessage("Kimlik doğrulama yapılıyor...");
        const isAuthenticated = await checkAuthentication();

        if (cancelled) return;

        if (!isAuthenticated) {
          setMessage("Giriş yapmanız gerekmektedir, yönlendiriliyor...");
          setTimeout(() => {
            navigate(`/login?route=/invite/${uniqid}/${title}`, {
              state: { from: `/invite/${uniqid}` }
            });
          }, 1500);
          return;
        }

        setMessage("Projeye katılım sağlanıyor...");
        await handleJoinProject();
      } catch (e) {
        if (cancelled) return;
        console.error("Invite akışı hata:", e);
        setMessage("Bir hata oluştu, ana sayfaya yönlendiriliyor...");
        setTimeout(() => navigate("/dashboard"), 1500);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [uniqid, title, navigate, handleJoinProject]);

  return (
    <div className="invite-page-container">
      <div className="invite-logo">
        <img src="/logo_blue.svg" alt="Logo" className="logo" />
      </div>
      <div className="invite-message">
        <p>{message}</p>
      </div>
      <div className="loader"></div>
    </div>
  );
};

export default InvitePage;
